import type { ShouldShowBehavior } from 'owa-filterable-menu';
import type { ListViewBehavior } from './Behaviors.types';

/**
 * Calculate the should show behavior based on a list of behaviors.
 * @param behaviors Collection of behaviors.
 */
export function shouldShowMenuItem(
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (12,5): Type 'null' is not assignable to type 'ListViewBehavior | ListViewBehavior[]'.
    // @ts-expect-error
    behaviors: ListViewBehavior | ListViewBehavior[] = null
): ShouldShowBehavior {
    // If no behavior is specified show the menu item
    if (!behaviors) {
        return () => true;
    }

    if (Array.isArray(behaviors[0])) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2345 (23,76): Argument of type 'ListViewBehavior | (() => boolean)' is not assignable to parameter of type 'ListViewBehavior'.
        // @ts-expect-error
        return () => behaviors.some(behavior => shouldShowOnSingleBehavior(behavior));
    } else {
        return () => shouldShowOnSingleBehavior(behaviors as ListViewBehavior);
    }
}

/**
 * Calculate the shouldShowResult based on a single list view behavior
 * @param behavior the single behavior function
 */
function shouldShowOnSingleBehavior(behavior: ListViewBehavior): boolean {
    return behavior.every(fn => fn());
}
